import { createFileRoute, notFound } from "@tanstack/react-router";

// Legacy /essays/{slug} requests are resolved at the request boundary
// (src/start.ts): 301 only to an existing published essay, otherwise 404.
export const Route = createFileRoute("/essays/$slug")({
  beforeLoad: () => {
    throw notFound();
  },
  component: () => null,
});
